module.exports = __webpack_public_path__ + "static/media/FLN2.c1bfa74a.png";